import React, { useCallback, useEffect, useState } from "react";
import {
  Row,
  Col,
  Space,
  Button,
  Breadcrumb,
  Form,
  theme,
  Divider,
  Input,
  Select
} from "antd";
import _ from "lodash";
import { useDropzone } from "react-dropzone";
import { useParams, useNavigate } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import { routes } from "../../../routes";
import Heading from "../../../components/common/heading";
import WithSidebar from "../../../templates/withSidebar";
import SuccessModal from "../../../components/modal/successModal";
import FailModal from "../../../components/modal/failModal";
import TableNameList from "./components/table";
import {
  updateIndicatorByYear,
  getListDivisions,
  getListDepartments,
  getProjectByYearlyProject
} from "../../../services/progressPerformance";
import { SUCCESS_CODE } from "../../../lib/const";

// const baseStyle = {
//   flex: 1,
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   width: "100%",
//   padding: "20px",
//   marginBottom: "20px",
//   borderWidth: 2,
//   borderRadius: 2,
//   borderColor: "#eeeeee",
//   borderStyle: "dashed",
//   backgroundColor: "#fafafa",
//   outline: "none",
//   transition: "border .24s ease-in-out"
// };

// const baseStyleHover = {
//   flex: 1,
//   display: "flex",
//   flexDirection: "column",
//   alignItems: "center",
//   width: "100%",
//   padding: "20px",
//   marginBottom: "20px",
//   borderWidth: 2,
//   borderRadius: 2,
//   borderColor: "#2E90FA",
//   borderStyle: "dashed",
//   backgroundColor: "#fafafa",
//   outline: "none",
//   transition: "border .24s ease-in-out"
// };

const { useToken } = theme;
const { Option } = Select;

export const AddKPI = () => {
  const navigate = useNavigate();
  const { token } = useToken();
  const params = useParams();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);
  // const [isHover, setIsHover] = useState(false);
  const [listProject, setListProject] = useState([]);
  const [tableList, setTableList] = useState([]);
  const [dropDownDepartment, setDropDownDepartment] = useState([]);
  const [dropDownDivision, setDropDownDivision] = useState([]);
  const [departmentId, setDepartmentId] = useState();
  const [divisionId, setDivisionId] = useState();
  const [errorMessage, setErrorMessage] = useState("");

  //TABLE FUNCTION
  const [dataSource, setDataSource] = useState([]);
  const [editingRow, setEditingRow] = useState(null);
  const [tableAction, settableAction] = useState(false);
  const [statusBT, setStatusBT] = useState(false);

  // const handleMouseEnter = () => {
  //   setIsHover(true);
  // };
  // const handleMouseLeave = () => {
  //   setIsHover(false);
  // };

  // const onDrop = async () => {};
  // const { getRootProps, getInputProps } = useDropzone({
  //   onDrop,
  //   multiple: false
  // });

  const handleAdd = () => {
    const newDataSource = {
      key: Number(tableList.length),
      departmentId: "",
      departmentNameEn: "",
      departmentNameTh: "",
      divisionId: "",
      divisionNameEn: "",
      divisionNameTh: "",
      projectId: "",
      projectNameEn: "",
      projectNameTh: "",
      projectAction: "ADD"
    };

    setDataSource((prevDataSource) => [...prevDataSource, newDataSource]);
    setTableList((prevTableList) => [...prevTableList, newDataSource]);
  };

  const handleEdit = (value, index, key) => {
    const findData = listProject.find((v) => v.projectId === value);

    setTableList((prevTableList) =>
      prevTableList.map(
        (project) =>
          project.key === index
            ? {
                ...project,
                ...{
                  key: project.key,
                  // [key]: value,
                  divisionId: _.get(findData, "divisionId"),
                  divisionNameEn: _.get(findData, "divisionNameEn"),
                  divisionNameTh: _.get(findData, "divisionNameTh"),
                  projectId: _.get(findData, "projectId"),
                  projectNameEn: _.get(findData, "projectNameEn"),
                  projectNameTh: _.get(findData, "projectNameTh"),
                  departmentId: _.get(findData, "departmentId"),
                  departmentNameEn: _.get(findData, "departmentNameEn"),
                  departmentNameTh: _.get(findData, "departmentNameTh"),
                  projectAction: _.isEmpty(project.projectAction)
                    ? "ADD"
                    : project.projectAction
                }
              }
            : {
                ...project,
                ...{
                  projectAction: _.isEmpty(project.projectAction)
                    ? "NONE"
                    : project.projectAction
                }
              } // Leave other projects unchanged
      )
    );

    setDataSource((prevDataSource) =>
      prevDataSource.map(
        (project) =>
          project.key === index
            ? {
                ...project,
                ...{
                  key: project.key,
                  // [key]: value,
                  divisionId: _.get(findData, "divisionId"),
                  divisionNameEn: _.get(findData, "divisionNameEn"),
                  divisionNameTh: _.get(findData, "divisionNameTh"),
                  projectId: _.get(findData, "projectId"),
                  projectNameEn: _.get(findData, "projectNameEn"),
                  projectNameTh: _.get(findData, "projectNameTh"),
                  departmentId: _.get(findData, "departmentId"),
                  departmentNameEn: _.get(findData, "departmentNameEn"),
                  departmentNameTh: _.get(findData, "departmentNameTh"),
                  projectAction: _.isEmpty(project.projectAction)
                    ? "ADD"
                    : project.projectAction
                }
              }
            : {
                ...project,
                ...{
                  projectAction: _.isEmpty(project.projectAction)
                    ? "NONE"
                    : project.projectAction
                }
              } // Leave other projects unchanged
      )
    );

    // setDataSource((prevDataSource) =>
    //   prevDataSource.map(
    //     (project) =>
    //       project.key === index
    //         ? {
    //             ...project,
    //             ...{
    //               key: project.key,
    //               [key]: value,
    //               projectAction: "UPDATE",
    //             },
    //           } // Update the object with the new data
    //         : {
    //             ...project,
    //             ...{
    //               projectAction: _.isEmpty(project.projectAction)
    //                 ? "NONE"
    //                 : project.projectAction,
    //             },
    //           } // Leave other projects unchanged
    //   )
    // );
  };

  const onSaveTable = async (values) => {};

  const handleDeleteReccord = (record) => {
    setDataSource((pre) => {
      return pre.filter((table) => table.key != record.key);
    });

    setTableList((prevDataSource) =>
      prevDataSource.map((project) =>
        project.key === record.key
          ? {
              ...project,
              ...{
                projectAction: "REMOVE"
              }
            } // Update the object with the new data
          : {
              ...project,
              ...{
                projectAction: _.isEmpty(project.projectAction)
                  ? "NONE"
                  : project.projectAction
              }
            }
      )
    );
  };

  const handleChange = (value, key) => {
    setDepartmentId(value);
    setListProject([]);
    form.setFields([
      {
        name: "divisionId",
        value: undefined
      }
    ]);
  };

  const onFinish = async (values) => {
    if (dataSource.length > 0) {
      const findDataSource = _.compact(
        tableList.map((v) => {
          if (v.projectAction === "REMOVE" && _.isEmpty(v.departmentId)) return;

          return {
            projectId: v.projectId,
            projectAction: v.projectAction ? v.projectAction : "NONE"
          };
        })
      );

      const hasDuplicates = findDataSource
        .map((item) => item.projectId)
        .some((id, index, arr) => arr.indexOf(id) !== index);

      if (hasDuplicates) {
        setFailModal(true);
        setErrorMessage("ไม่สามารถเลือกโครงการที่ซ้ำกันได้");
      } else {
        const request = {
          yearOfBudget: params.year,
          data: [
            {
              indicatorNameTh: form.getFieldValue().indicatorNameTh,
              indicationAction: "CREATE", // CREATE, UPDATE, DELETE, NONE
              departmentId: form.getFieldValue().departmentId,
              divisionId: form.getFieldValue().divisionId,
              projects: findDataSource
            }
          ]
        };

        const res = await updateIndicatorByYear(request);
        let errorMessage = _.get(
          res.data.objectValue,
          "indicators[0].errorMessage"
        );

        const duplicateProject = _.find(
          _.get(res.data.objectValue, "indicators[0].projects"),
          function (n) {
            if (n.errorMessage !== null) {
              return true;
            }
          }
        );

        if (res.data.code === SUCCESS_CODE) {
          if (errorMessage) {
            if (errorMessage === "Data duplicate.") {
              setFailModal(true);
              setErrorMessage("ตัวชี้วัดดังกล่าวมีอยู่ในระบบเรียบร้อยแล้ว");
            } else {
              setErrorMessage("");
              setFailModal(true);
              setTimeout(() => {
                setFailModal(false);
              }, 2000);
            }
          } else {
            if (duplicateProject) {
              setFailModal(true);
              setErrorMessage("ไม่สามารถเลือกโครงการที่ซ้ำกันได้");
            } else {
              setSuccessModal(true);
              setTimeout(() => {
                navigate(routes.progress_tab_kpi);
                setSuccessModal(false);
              }, 2000);
            }
          }
        } else {
          setErrorMessage("");
          setFailModal(true);
          setTimeout(() => {
            setFailModal(false);
          }, 2000);
        }
      }
    } else {
      setFailModal(true);
      setErrorMessage("กรุณาเพิ่มโครงการอย่างน้อย 1 โครงการ");
    }
  };

  const fetchListDepartments = useCallback(async () => {
    try {
      const res = await getListDepartments();

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDepartment(result_data);
      }
    } catch (error) {}
  }, [dropDownDepartment]);

  const fetchListDivisions = useCallback(async () => {
    try {
      const res = await getListDivisions(departmentId);

      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDropDownDivision(result_data);
      }
    } catch (error) {}
  }, [departmentId]);

  const fetchProjectByYearlyPlan = async () => {
    const request = {
      departmentId: form.getFieldValue().departmentId
        ? form.getFieldValue().departmentId
        : "",
      divisionId: form.getFieldValue().divisionId
        ? form.getFieldValue().divisionId
        : "",
      yearOfBudget: params.year
    };

    const res = await getProjectByYearlyProject(request);
    if (res.data.code === SUCCESS_CODE) {
      let result_data = res.data.objectValue;
      setListProject(result_data);
    }
  };

  useEffect(() => {
    fetchProjectByYearlyPlan();
  }, [departmentId, divisionId, params.year]);

  useEffect(() => {
    fetchListDepartments();
  }, []);

  useEffect(() => {
    if (departmentId) {
      fetchListDivisions();
    }
  }, [departmentId]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.progress_tab_kpi);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading
                  text={"เพิ่มตัวชี้วัด"}
                  size={4}
                  style={{ margin: 0 }}
                />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "ตัวชี้วัด"
                },
                {
                  title: "รายละเอียด"
                },
                {
                  title: <span className="pr_green">เพิ่มตัวชี้วัด</span>
                }
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                <Col span={24} align="right">
                  <Space>
                    <Button
                      onClick={() => {
                        setOpenCancelModal(true);
                        setPreviousPage(routes.progress_tab_kpi);
                      }}
                    >
                      ยกเลิก
                    </Button>
                    <Button type="primary" htmlType="submit">
                      บันทึก
                    </Button>
                  </Space>
                </Col>
              </Row>

              <Row gutter={[16, 8]} className="card">
                <Col span={24}>
                  <Row gutter={16}>
                    <Col span={18}>
                      <Heading
                        text={`ปีงบประมาณ${" " + params.year}`}
                        size={4}
                        style={{ margin: 0, color: token.thPrimary }}
                      />
                    </Col>
                  </Row>
                  <Divider />
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="ชื่อตัวชี้วัด"
                    name={"indicatorNameTh"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ"
                      }
                    ]}
                  >
                    <Input placeholder="กรุณากรอกช้อมูล" />
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label="ฝ่าย"
                    name={"departmentId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={handleChange}
                    >
                      {dropDownDepartment.map((option) => (
                        <Option value={option.departmentId}>
                          {option.departmentNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12} className="gutter-row">
                  <Form.Item
                    label="กอง"
                    name={"divisionId"}
                    rules={[
                      {
                        required: true,
                        message: "โปรดระบุ"
                      }
                    ]}
                  >
                    <Select
                      allowClear
                      style={{
                        width: "100%"
                      }}
                      placeholder="กรุณาเลือก"
                      onChange={(e) => {
                        setListProject([]);
                        setDivisionId(e);
                      }}
                    >
                      {dropDownDivision.map((item) => (
                        <Option value={item.divisionId}>
                          {item.divisionNameTh}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={24} style={{ marginTop: "12px" }}>
                  <TableNameList
                    dataSource={dataSource}
                    editingRow={editingRow}
                    canEdit={true}
                    canView={false}
                    handleAdd={handleAdd}
                    handleEdit={handleEdit}
                    onSaveTable={onSaveTable}
                    handleDeleteReccord={handleDeleteReccord}
                    statusBT={statusBT}
                    tableAction={tableAction}
                    year={params.year}
                    listProject={listProject}
                  />
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </div>

      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal
        title={errorMessage ? errorMessage : ""}
        subTitle={errorMessage ? "กรุณาทำการตรวจสอบข้อมูล" : ""}
        open={failModal}
        setOpen={setFailModal}
        setErrMsg={setErrorMessage}
      />
    </WithSidebar>
  );
};
